import React, {ChangeEvent, FC, MouseEvent, ReactNode, useRef} from 'react';
import styles from './RsnUploadButton.module.scss';

export interface RsnUploadButtonProps {
    accept?: string;
    capture?: 'user' | 'environment' | boolean;
    multiple?: boolean;
    onChangeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
    children?: ReactNode;
    disabled?: boolean;
}

const RsnUploadButton: FC<RsnUploadButtonProps> = ({
    accept,
    capture,
    multiple,
    onChangeHandler,
    children,
    disabled,
}) => {
    const ref = useRef<HTMLInputElement>(null);

    const clickOnInput = (e: MouseEvent) => {
        e.preventDefault();
        ref.current?.click();
    };

    // enable to fire onChange event with the same file as previous
    const resetValue = (e: MouseEvent<HTMLInputElement>) => (e.currentTarget.value = '');

    return (
        <div className={`${styles.uploadButton} }`}>
            <input
                ref={ref}
                accept={accept}
                type='file'
                multiple={multiple}
                onClick={resetValue}
                onChange={onChangeHandler}
                className={styles.notDisplayed}
                capture={capture}
                disabled={disabled}
            />
            <button type='button' onClick={clickOnInput}>
                {children}
            </button>
        </div>
    );
};

export default RsnUploadButton;
